module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2494271"
    }
  }, [_c('b', [_vm._v("BROWN BEEF STOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2494771"
    }
  }, [_c('b', [_c('i', [_vm._v("For a richer, meatier flavor, use four pounds of beef bones and one pound of oxtails.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2495771"
    }
  }, [_c('b', [_vm._v("Prep: 5 minutes Cook: 7 hours 30 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2496271"
    }
  }, [_vm._v("5 pounds beef bones, cut into 3-inch pieces")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2496571"
    }
  }, [_vm._v("2 medium onions, each cut in half")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2496871"
    }
  }, [_vm._v("3 carrots, peeled and each cut in half")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2497171"
    }
  }, [_vm._v("2 stalks celery, each cut in half")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2497471"
    }
  }, [_vm._v("13 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2497771"
    }
  }, [_vm._v("1 small bunch parsley")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2498171"
    }
  }, [_vm._v("1 bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2498771"
    }
  }, [_vm._v("½ teaspoon dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2499871"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" Preheat oven to 450°F. Spread beef bones, onions, carrots, and celery in large roasting pan (17½\" by 11½\"). Roast, stirring every 15 minutes, until well browned, about 1 hour.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2503171"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" With tongs, transfer browned bones and vegetables to 6-quart saucepot. Carefully pour off fat from roasting pan. Add 1 cup water to roasting pan and heat to boiling, stirring until browned bits are loosened from bottom of pan; add to pot. Add remaining 12 cups water, parsley, bay leaf, and thyme to pot. Heat to boiling over high heat, skimming foam from surface. Reduce heat and simmer, skimming foam occasionally, 6 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2507171"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Strain broth through colander into large bowl; discard solids. Strain again through fine-mesh sieve into containers. Cool. Cover and refrigerate to use within 3 days, or freeze up to 4 months.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2508871"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("4.")])]), _vm._v(" To use, skim and discard fat from surface of stock. Makes about 5 cups.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2510271"
    }
  }, [_vm._v("Each cup: About 39 calories, 5g protein, 5g carbohydrate, 0g total fat (0g saturated), 0mg cholesterol, 73mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8573953a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c75_r1.vue
// module id = 291
// module chunks = 0